import { z } from 'zod';

export const loginSchema = z.object({
  email: z.email({ error: 'auth:validation.email' }),
  password: z.string().min(1, { error: 'auth:validation.required' }),
});

export type LoginValues = z.infer<typeof loginSchema>;
